import { memo, useState, useEffect } from "react";
import GameResults from "./GmesResults/GameResults";
import MultiPlayTable from "./MultiPlayTable/MultiPlayTable";
import PlayTable from "./PlayTable/PlayTable";

function DeluxResults({ resultsData, getRoundID }) {
  const tables = [
    <PlayTable getRoundID={getRoundID} />,
    <MultiPlayTable />,
    <GameResults resultsData={resultsData} />
  ];
  const [index, setIndex] = useState(0);
  const indexItem = index % tables.length;
  useEffect(() => {
    const timing = () => setIndex((i) => i + 1);

    const id = setInterval(timing, 10000);
    return () => clearInterval(id);
  }, []);

  const style ={
    "animation": "animate-width 5s linear"
  }
  return (
    <div style={{width: "22%", height: "88%"}}>
      {tables[indexItem]}
      <div className="active-tab">
        {
          tables.map((item, i) => (
            <span className="tab-bg" key={i}>
              <span className={indexItem === i ? "active" : ""}></span>
            </span>
          ))
        }
      </div>
    </div>
  );
}

export default memo(DeluxResults);
